export default __webpack_public_path__ + "static/media/step1filled.a9ce8cf5.png";